module.exports = __webpack_public_path__ + "img/logo.162fd2e7.png";